'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = qualityChangedListener;

var _actions = require('../../store/actions');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * The `qualityChanged` listener is fired once a requested quality is
 * loaded into the buffers. We use this opportunity to update the quality
 * toggle to indicate the quality has successfully changed.
 */
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule defaultQualityChangedListener
 * 
 */

function qualityChangedListener(state, next, playerId) {
  /*
   * We are using the `updateState` method here instead of `next`
   * because we need to `force` the update.
   *
   * This is necassary because these quality objects are currently
   * instances of a class. And there is no good way for our intersection
   * logic to verify that they are different instances of the same class without
   * enumerable properties. Which sucks.. I think this can go away when VP
   * 'normalizes' the quality objects as they shouldn't be classes then
   */
  _store2.default.storeInstance().dispatch((0, _actions.setQualityInternal)(playerId, _store2.default.getPlayerInstance(playerId).currentQuality, false));
}
module.exports = exports['default'];